import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { ConfigService } from '../ConfigService/config.service';
import { InitializationModel } from './initialization.model';
import { AuthStatusService } from '../AuthStatusService/auth-status.service';
import { EmployeeSideService } from '../EmployeeSideService/employee-side.service';
import { EmployeeInitializationService } from './employee-initialization.service';

export class EmployeeInitializationServiceFactory
{
    static create(
        config: IAppConfig,
        spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService,
        configService?: ConfigService,
        initializationModel?: InitializationModel,
        authStatusService?: AuthStatusService,
        employeeSideService?: EmployeeSideService
    ): EmployeeInitializationService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);

        return new EmployeeInitializationService(
            configService,
            authenticationService,
            initializationModel,
            authStatusService,
            employeeSideService,
            httpProvider
        );
    }
}
